<template>
  <div
    class="el-main"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="AIがあなたに最適なテキストを生成しています"
  >
    <div class="card" v-show="currentCardId == 'edu-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>学歴を入力</h2>
          <p>「自動入力」を使うと、入学・卒業年度を自動で計算できます</p>
          <el-checkbox v-model="formatData.notDisplayIjyo"
            >【以上】を表示しない</el-checkbox
          >
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <div class="edu-history-action">
              <auto-educational-backgrounds
                v-on:create-educational-background="setEducationalBackgrounds"
                :year="basicData.birthYear"
                :month="basicData.birthMonth"
                :day="basicData.birthDay"
              ></auto-educational-backgrounds>
              <div class="button-reset">
                <el-button
                  v-if="
                    formatData.educationalHistories &&
                    formatData.educationalHistories.length > 1
                  "
                  @click="$modal.show('educational-reset')"
                  >リセット</el-button
                >
              </div>
              <modal
                name="educational-reset"
                :adaptive="true"
                :scrollable="true"
                height="auto"
              >
                <div class="v--modal-close-top">
                  <el-button
                    @click="$modal.hide('educational-reset')"
                    icon="el-icon-close"
                    type="text"
                  ></el-button>
                </div>
                <div class="title">学歴リセット</div>
                <span
                  >入力されている学歴をすべて削除します。よろしいですか？</span
                >

                <div class="text-left">
                  <el-button
                    type="primary"
                    @click="
                      $modal.hide('educational-reset')
                      resetEducationalBackgrounds()
                    "
                    >リセットする</el-button
                  >
                  <el-button @click="$modal.hide('educational-reset')"
                    >リセットしない</el-button
                  >
                </div>
              </modal>
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">
              卒業予定 <span style="color: red">※卒年は必ず入力しましょう</span>
            </div>
            <div class="item-body">
              <el-select
                v-model="formatData.gradeYear"
                placeholder="選択してください"
              >
                <el-option
                  v-for="item in gradeYearOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item
                v-on:add-history-item="addEducationalHistory"
                v-on:delete-history-item="deleteEducationalHistory"
                v-on:move-history-item="moveEducationalHistory"
                v-for="(item, index) in formatData.educationalHistories"
                @click.native="activateHistoryItem(item.uuid)"
                :item="item"
                :length="formatData.educationalHistories.length"
                :index="index"
                :key="item.uuid"
                :id="item.uuid"
                :class="{ active: activeHistoryItem == item.uuid }"
                :minYear="basicData.birthYear"
                :ref="'EducationalHistory_' + index"
                :createDate="formatData.createDate"
                :descriptionPlaceholder="'学歴を入力'"
                :descriptionMaxLength="descriptionMaxLength"
              ></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button
                icon="el-icon-plus"
                circle
                type="success"
                @click="addEducationalHistory()"
              ></el-button>
            </div>
          </div>
          <div
            class="attention-limit column"
            v-if="previewErrors.eduJobHistory"
          >
            <i class="el-icon-warning"></i> {{ previewErrors.eduJobHistory }}
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'job-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>職歴を入力</h2>
          <p>「自動入力」を使うと、入社・退社表記を自動で作成できます。</p>
          <el-checkbox v-model="formatData.notDisplayIjyo"
            >【以上】を表示しない</el-checkbox
          >
        </div>
        <div class="card-content-list">
          <div class="edit-form-list">
            <div class="add-item">
              <auto-job-histories
                v-on:job-histories-created="setJobHistories"
                :birth-year="basicData.birthYear"
                :birth-month="basicData.birthMonth"
                :birth-day="basicData.birthDay"
              ></auto-job-histories>
              <div class="button-reset">
                <el-button
                  type=""
                  v-if="
                    formatData.jobHistories &&
                    formatData.jobHistories.length > 1
                  "
                  @click="$modal.show('job-reset')"
                  >リセット</el-button
                >
              </div>
              <modal
                name="job-reset"
                :adaptive="true"
                :scrollable="true"
                height="auto"
              >
                <div class="v--modal-close-top">
                  <el-button
                    @click="$modal.hide('job-reset')"
                    icon="el-icon-close"
                    type="text"
                  ></el-button>
                </div>
                <div class="title">職歴リセット</div>
                <span
                  >現在入力されている職歴をすべて削除します。よろしいですか？</span
                >
                <div>
                  <el-button
                    type="primary"
                    @click="
                      $modal.hide('job-reset')
                      resetJobHistories()
                    "
                    >リセットする</el-button
                  >
                  <el-button @click="$modal.hide('job-reset')"
                    >リセットしない</el-button
                  >
                </div>
              </modal>
            </div>
            <transition-group name="fade" tag="div">
              <history-item
                v-on:add-history-item="addJobHistory"
                v-on:delete-history-item="deleteJobHistory"
                v-on:move-history-item="moveJobHistory"
                v-for="(item, index) in formatData.jobHistories"
                @click.native="activateHistoryItem(item.uuid)"
                :item="item"
                :length="formatData.jobHistories.length"
                :index="index"
                :key="item.uuid"
                :id="item.uuid"
                :class="{ active: activeHistoryItem == item.uuid }"
                :ref="'JobHistory_' + index"
                :minYear="basicData.birthYear"
                :createDate="formatData.createDate"
                :descriptionPlaceholder="'職歴を入力'"
                :descriptionMaxLength="descriptionMaxLength"
              ></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button
                icon="el-icon-plus"
                circle
                type="success"
                @click="addJobHistory()"
              ></el-button>
            </div>
            <div
              class="attention-limit column"
              v-if="previewErrors.eduJobHistory"
            >
              <i class="el-icon-warning"></i>&ensp;{{
                previewErrors.eduJobHistory
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'license-history'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>免許・資格を入力</h2>
          <p>主要な免許・資格は例文から選ぶことができます</p>
        </div>
        <div class="card-content-list">
          <div class="add-item">
            <el-button @click="$modal.show('license-dialog')" type="success"
              >例文から追加</el-button
            >
            <modal
              name="license-dialog"
              :adaptive="true"
              :scrollable="true"
              height="auto"
            >
              <div class="v--modal-close-top">
                <el-button
                  @click="$modal.hide('license-dialog')"
                  icon="el-icon-close"
                  type="text"
                ></el-button>
              </div>
              <div class="title">例文を選ぶ</div>
              <div class="description">
                <p>選択した例文が追加されます。</p>
              </div>
              <ul class="example-sentence">
                <li
                  v-for="(item, idx) in exampleSentences.license"
                  v-on:click="
                    addLicenseHistory(null, { description: item.description })
                    $modal.hide('license-dialog')
                  "
                  :key="idx"
                >
                  <div class="title">{{ item.title }}</div>
                  <div class="body" v-html="item.description"></div>
                </li>
              </ul>
              <div class="text-right">
                <el-button @click="$modal.hide('license-dialog')"
                  >閉じる</el-button
                >
              </div>
            </modal>
          </div>
          <div class="edit-form-list">
            <transition-group name="fade" tag="div">
              <history-item
                v-on:add-history-item="addLicenseHistory"
                v-on:delete-history-item="deleteLicenseHistory"
                v-on:move-history-item="moveLicenseHistory"
                v-for="(item, index) in formatData.licenseHistories"
                @click.native="activateHistoryItem(item.uuid)"
                :item="item"
                :length="formatData.licenseHistories.length"
                :index="index"
                :key="item.uuid"
                :id="item.uuid"
                :class="{ active: activeHistoryItem == item.uuid }"
                :ref="'LicenseHistory_' + index"
                :minYear="basicData.birthYear"
                :createDate="formatData.createDate"
                :descriptionPlaceholder="'免許・資格を入力'"
                :descriptionMaxLength="descriptionMaxLength"
              ></history-item>
            </transition-group>
            <div class="add-list-item">
              <el-button
                icon="el-icon-plus"
                circle
                type="success"
                @click="addLicenseHistory()"
              ></el-button>
            </div>
            <div
              class="attention-limit column"
              v-if="previewErrors.licenseHistory"
            >
              <i class="el-icon-warning"></i> {{ previewErrors.licenseHistory }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'reason'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>志望動機を入力</h2>
          <p>{{ reasonLabel }}</p>
        </div>

        <div class="add-item">
          <el-button @click="$modal.show('reason-dialog')" type="success"
            >例文から追加</el-button
          >
        </div>

        <div class="card-content">
          <modal
            name="reason-dialog"
            :adaptive="true"
            :scrollable="true"
            height="auto"
          >
            <div class="v--modal-close-top">
              <el-button
                @click="$modal.hide('reason-dialog')"
                icon="el-icon-close"
                type="text"
              ></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">
                例文を選択すると、現在入力中の文章は上書きされますのでご注意ください。
              </p>
            </div>
            <ul class="example-sentence">
              <li
                v-for="(item, idx) in exampleSentences.reason"
                v-on:click="
                  formatData.reason = item.description.replace(/<br>/gi, '\n')
                  $modal.hide('reason-dialog')
                "
                :key="idx"
              >
                <div class="title">{{ item.title }}</div>
                <div class="body" v-html="item.description"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('reason-dialog')"
                >閉じる</el-button
              >
            </div>
          </modal>
          <el-input
            type="textarea"
            v-model="formatData.reason"
            v-proofread
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"
          ></el-input>
          <div class="attention-limit character" v-if="previewErrors.reason">
            <i class="el-icon-warning"></i>
            入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'ai_mypr'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>AI自己PRを入力</h2>
          <p>
            質問に答えるだけで、AIがあなたの自己PRを作成してくれます。AIから提案された文章をご活用ください。<br />
            生成せず、自分で考えた文章を入力することも可能です。
          </p>
        </div>

        <div class="card-content">
          <div class="r-ai-format" v-if="!viewYagiprimepayment">
            <!--4つの質問-->
            <div v-if="!aiResultView">
              <ul class="example-sentence-list">
                <li class="example-sentence-item">
                  <p class="question-title">
                    質問1.得意な科目、研究テーマ、〇〇ゼミなど
                  </p>
                  <div class="el-textarea">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="数学・外国語など"
                      title="得意な科目、研究テーマ、〇〇ゼミなど"
                      autocomplete="off"
                      v-model="formatData.campus_history_content"
                    ></el-input>
                  </div>
                </li>
                <li class="example-sentence-item">
                  <p class="question-title">
                    質問2.質問1に関するエピソードなど
                  </p>
                  <div class="el-textarea">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="粘り強く諦めない"
                      title="質問1に関するエピソードなど"
                      autocomplete="off"
                      v-model="formatData.campus_history_summary"
                    ></el-input>
                  </div>
                </li>
                <li class="example-sentence-item">
                  <p class="question-title">質問3.学生生活で力を注いだこと</p>
                  <div class="el-textarea">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="アルバイトなど"
                      title="学生生活で力を注いだこと"
                      autocomplete="off"
                      v-model="formatData.gakuchika_content"
                    ></el-input>
                  </div>
                </li>
                <li class="example-sentence-item">
                  <p class="question-title">
                    質問4.質問3に関するエピソードなど
                  </p>
                  <div class="el-textarea">
                    <el-input
                      type="textarea"
                      autosize
                      placeholder="遅刻なし"
                      title="質問3に関するエピソードなど"
                      autocomplete="off"
                      v-model="formatData.gakuchika_summary"
                    ></el-input>
                  </div>
                </li>
              </ul>
              <div
                class="text-center r-btn-wrap prime-cv-block"
                style="margin-top: 0; margin-bottom: 20px"
              >
                <el-button
                  type="button"
                  @click="getAIMyprNew()"
                  class="r-ai-btn"
                  >この内容でAI自己PRを作成</el-button
                >
              </div>
            </div>

            <!--解答後の画面-->
            <div v-else>
              <ul
                class="example-sentence-list example-sentence-block"
                style="margin-bottom: 20px"
              >
                <li class="example-sentence-item">
                  <p class="question-title">AIに提案された自己PR</p>
                  <div class="body" v-html="aiCampusHistoryResult"></div>
                  <br />
                  <div class="body" v-html="aiGakuchikaResult"></div>
                  <div class="flex prime-cv-block prime-cv-block-flex">
                    <el-button
                      v-on:click="
                        formatData.reasonNew =
                          aiCampusHistoryResult.replace(/<br>/gi, '\n') +
                          '\n' +
                          '\n' +
                          aiGakuchikaResult.replace(/<br>/gi, '\n') +
                          '\n'
                      "
                    >
                      <span>{{
                        $globalVar.isYagiPrime
                          ? 'この自己PRを使う'
                          : '途中までの自己PRを使う'
                      }}</span>
                    </el-button>
                    <div
                      v-if="!$globalVar.isYagiPrime"
                      class="text-center r-btn-wrap prime-cv-block"
                      style="margin-top: 0"
                    >
                      <el-button
                        type="button"
                        @click="viewPaymentYagiprime"
                        class="r-ai-btn"
                        style="line-height: 1.2; padding: 3px 34px"
                        ><span>ヤギプライムに加入して</span
                        ><br />文章全体を取得する</el-button
                      >
                    </div>
                  </div>
                </li>
              </ul>
              <div
                class="text-center r-btn-wrap prime-cv-block"
                v-if="$globalVar.isYagiPrime"
                style="margin-bottom: 20px"
              >
                <el-button
                  type="button"
                  v-on:click="aiResultView = false"
                  class="r-ai-btn"
                  >再度質問に答えて取得する</el-button
                >
              </div>

              <!--<div class="title" style="text-align: center;" v-if="!$globalVar.isYagiPrime">
                AI履歴書はいかがでしたか？納得しなかった方はプロに見てもらいましょう！</div>
              <div class="text-center r-btn-wrap" v-if="!$globalVar.isYagiPrime">
                <el-button v-if="$globalVar.in_app_payments" type="button" @click="viewPaymentYagiprime"
                  class="r-ai-btn">プロに相談する</el-button>
              </div>-->
            </div>
          </div>
          <div v-if="viewYagiprimepayment" class="ai-payment-card-box">
            <el-button
              v-ripple
              @click="$eventHub.$emit('go-card-to', 'output')"
              type="success"
              id="prime-payment-btn"
            >
              AI志望動機を利用せず、<br />無料で履歴書作成をつづける
              <i class="el-icon-d-arrow-right"></i>
            </el-button>
            <div class="container-base r-ai-format">
              <div class="overflow-scroll-y" v-if="!completeBuyYagiprime">
                <YagiprimeWrapper />
              </div>
              <div class="overflow-scroll-y" v-else>
                <div class="card-header">
                  <h2>ヤギプライムに登録</h2>
                  <p>登録完了しました。</p>
                  <p style="color: red">※無料エージェント機能を使いますか？</p>
                </div>
                <div class="card-content" style="padding: 0px">
                  <div class="edit-form-item">
                    <div>
                      <div>
                        <div class="card">
                          <div class="overflow-scroll-y">
                            <div class="card-header">
                              <h2>担当エージェント会社の確認</h2>
                            </div>
                            <div class="card-content">
                              <div class="edit-form">
                                <div class="edit-form-item">
                                  <div
                                    class="item-body"
                                    style="margin-left: 10px"
                                  >
                                    居住地：{{ basicData.address1 }}
                                  </div>
                                  <div
                                    class="item-body"
                                    style="margin-left: 10px"
                                  >
                                    希望職種：{{ formatData.hopeJobcategory }}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="card-content">
                              <div class="edit-form" v-if="isMatching && false">
                                <div class="edit-form-item">
                                  <div class="item-name">
                                    <h3 class="h3">
                                      <span
                                        >会社名：{{
                                          matchingCompany.company_name
                                        }}</span
                                      >
                                      <p>
                                        {{ matchingCompany.company_address1 }}
                                      </p>
                                      <img
                                        v-if="matchingCompany.company_logo"
                                        :src="matchingCompany.company_logo"
                                        style="width: 50%"
                                      />
                                    </h3>
                                  </div>
                                  <p style="font-size: 80%">
                                    Yagishの<router-link
                                      id="footer-link-terms"
                                      :to="{ name: 'termsPage' }"
                                      target="_blank"
                                      >利用規約</router-link
                                    >、<router-link
                                      id="footer-link-policy"
                                      :to="{ name: 'policyPage' }"
                                      target="_blank"
                                      >個人情報保護方針</router-link
                                    >と {{ matchingCompany.company_name }}の<a
                                      :href="matchingCompany.terms_url"
                                      target="_blank"
                                      >利用規約</a
                                    >、<a
                                      :href="matchingCompany.privacy_url"
                                      target="_blank"
                                      >個人情報保護方針</a
                                    >を確認して{{
                                      matchingCompany.company_name
                                    }}に登録することになります。
                                  </p>
                                  <p
                                    style="
                                      font-size: 1rem;
                                      font-weight: bold;
                                      margin-top: 10px;
                                    "
                                  >
                                    <img
                                      src="/static/renew_img/check_icon.png"
                                      alt="同意する"
                                      style="height: 30px"
                                    />
                                    規約に同意する
                                  </p>
                                </div>
                                <div class="text-center r-btn-wrap">
                                  <el-button
                                    type="button"
                                    @click="getAIMypr()"
                                    class="r-ai-btn"
                                    >このエージェントにお願いする</el-button
                                  >
                                </div>
                              </div>
                              <div class="edit-form" v-else-if="isMatching">
                                <div class="yp-agent-register">
                                  <div class="card-header">
                                    <h2 class="yp-h2">
                                      もっとヤギプライムを活用するために
                                    </h2>
                                    <p>
                                      特別に無料エージェント紹介を受けられます（Yagishと提携の会社による）。面接に進む等、最終的な判断はあなたに委ねられますのでご安心ください。
                                    </p>
                                  </div>
                                  <div class="card-content">
                                    <div>
                                      <div>
                                        <p>居住地：{{ basicData.address1 }}</p>
                                        <p>
                                          希望職種：{{
                                            formatData.hopeJobcategory
                                          }}
                                        </p>
                                      </div>
                                      <div class="yp-agent-list">
                                        <!--エージェントがある場合-->
                                        <div class="renew2_flex agent-info">
                                          <img
                                            v-if="matchingCompany.company_logo"
                                            :src="matchingCompany.company_logo"
                                            alt="該当エージェント"
                                            class="agent-logo"
                                          />
                                          <div>
                                            <p class="agent-txt">
                                              会社名：{{
                                                matchingCompany.company_name
                                              }}
                                            </p>
                                            <p class="agent-txt">
                                              {{
                                                matchingCompany.company_address1
                                              }}
                                            </p>
                                          </div>
                                        </div>

                                        <!--見つからない場合-->
                                        <!--<p class="yp-agent-lead">該当するエージェントが見つかりませんでした。条件を変更すると良いエージェントが見つかるかも知れません。</p>-->

                                        <p class="yp-agent-memo">
                                          Yagishの<a
                                            href="/terms"
                                            id="footer-link-terms"
                                            target="_blank"
                                            >利用規約</a
                                          >、<a
                                            href="https://www.yagish.jp/privacy/"
                                            class="router-link-active"
                                            id="footer-link-policy"
                                            target="_blank"
                                            >個人情報保護方針</a
                                          >と
                                          {{ matchingCompany.company_name }}の<a
                                            :href="matchingCompany.terms_url"
                                            target="_blank"
                                            >利用規約</a
                                          >、<a
                                            :href="matchingCompany.privacy_url"
                                            target="_blank"
                                            >個人情報保護方針</a
                                          >を確認して{{
                                            matchingCompany.company_name
                                          }}に登録することになります。
                                        </p>
                                        <div class="flex consent-txt">
                                          <img
                                            src="/static/renew3_img/carat_img/caratcheck_icon.svg"
                                            alt="チェック"
                                            class="consent-icon"
                                          />
                                          <p>
                                            {{
                                              matchingCompany.company_name
                                            }}の利用規約に同意する
                                          </p>
                                        </div>
                                      </div>
                                      <div class="flex consent-txt">
                                        <img
                                          src="/static/renew3_img/carat_img/caratcheck_icon.svg"
                                          alt="チェック"
                                          class="consent-icon"
                                        />
                                        <p>Yagishの利用規約に同意する</p>
                                      </div>
                                      <div class="text-center r-btn-wrap">
                                        <button
                                          type="button"
                                          @click="applyAgent()"
                                          class="el-button el-button--button r-ai-btn"
                                        >
                                          <!----><!----><span
                                            >無料エージェントを希望する</span
                                          >
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="edit-form" v-else>
                                <div class="yp-agent-register">
                                  <div class="card-content">
                                    <div>
                                      <div>
                                        <p>居住地：{{ basicData.address1 }}</p>
                                        <p>
                                          希望職種：{{
                                            formatData.hopeJobcategory
                                          }}
                                        </p>
                                      </div>
                                      <div class="yp-agent-list">
                                        <!--見つからない場合-->
                                        <p class="yp-agent-lead">
                                          該当するエージェントが見つかりませんでした。条件を変更すると良いエージェントが見つかるかも知れません。
                                        </p>
                                      </div>
                                      <div class="flex consent-txt">
                                        <img
                                          src="/static/renew3_img/carat_img/caratcheck_icon.svg"
                                          alt="チェック"
                                          class="consent-icon"
                                        />
                                        <p>Yagishの利用規約に同意する</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="edit-form-item">
                                  <p style="color: red">
                                    該当するエージェントが見つかりませんでした。条件を変更すると良いエージェントが見つかるかも知れません。
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-input
            type="textarea"
            v-model="formatData.reasonNew"
            v-proofread
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"
            placeholder="AI自己PRを作成すると、文章が入力されます。また、自分で考えた文章を入力することも可能です。"
          ></el-input>
          <div class="attention-limit character" v-if="previewErrors.reason">
            <i class="el-icon-warning"></i>
            入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'others'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>通勤時間ほか</h2>
          <p>通勤時間や扶養家族などを入力します</p>
        </div>
        <div class="card-content">
          <div class="edit-form">
            <div
              class="edit-form-item"
              v-if="
                optionItems.commuteDescription &
                (this.formatId != 'rirekisho_job_new')
              "
            >
              <div class="item-name">
                通勤手段<small>（電車・バス・自家用車など）</small>
              </div>
              <div class="item-body">
                <el-input
                  class="input-md"
                  type="textarea"
                  placeholder="電車（JR◯◯線）"
                  v-model="formatData.commuteDescription"
                  :autosize="{ minRows: 1, maxRows: 2 }"
                >
                </el-input>
                <!--{{ $formLib.charCount(formatData.commuteDescription) }}-->
                <div
                  class="error attention-limit character"
                  v-if="$formLib.charCount(formatData.commuteDescription) > 84"
                >
                  <i class="el-icon-warning"></i>
                  入力可能な文字数をオーバーしています。
                </div>
              </div>
            </div>
            <div class="edit-form-item">
              <div class="item-name">通勤時間</div>
              <div class="item-body">
                <el-input
                  class="input-xs"
                  placeholder=""
                  title="時間"
                  type="number"
                  v-model="formatData.commuteHours"
                ></el-input>
                時間
                <el-input
                  class="input-xs"
                  type="number"
                  placeholder=""
                  title="分"
                  v-model="formatData.commuteMinutes"
                ></el-input>
                分
              </div>

              <div class="item-name">扶養家族（配偶者を除く）</div>
              <div class="item-body">
                <el-input
                  class="input-xs"
                  placeholder=""
                  title="扶養家族の人数"
                  type="number"
                  v-model="formatData.spouseNumber"
                ></el-input>
                人
              </div>
              <div class="item-name">配偶者</div>
              <div class="item-body">
                <el-radio v-model="formatData.hasSpouse" :label="true">
                  あり</el-radio
                >
                <el-radio v-model="formatData.hasSpouse" :label="false">
                  なし</el-radio
                >
              </div>
              <div class="item-name">配偶者の扶養義務</div>
              <div class="item-body">
                <el-radio v-model="formatData.underDutyToSupport" :label="true"
                  >あり</el-radio
                >
                <el-radio v-model="formatData.underDutyToSupport" :label="false"
                  >なし</el-radio
                >
              </div>
              <br />
              <div
                class="item-name"
                v-if="
                  formatId == 'rirekisho_job_new' ||
                  formatId == 'rirekisho_job_new_single'
                "
              >
                あなたは留学生ですか。
              </div>
              <div
                class="item-body"
                v-if="
                  formatId == 'rirekisho_job_new' ||
                  formatId == 'rirekisho_job_new_single'
                "
              >
                <el-radio v-model="formatData.foreignStudent" :label="true"
                  >はい</el-radio
                >
                <el-radio v-model="formatData.foreignStudent" :label="false"
                  >いいえ</el-radio
                >
              </div>
              <!--<el-checkbox v-model="formatData.notDisplayRecommend">紹介・推薦を表示しない</el-checkbox>-->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'requests'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>本人希望欄を入力</h2>
          <p>給与・職種・勤務時間・勤務地などの希望を入力します（任意）</p>
        </div>
        <div class="add-item">
          <el-button @click="$modal.show('request-dialog')" type="success"
            >例文から追加</el-button
          >
        </div>
        <div class="card-content">
          <br />
          <modal
            name="request-dialog"
            :adaptive="true"
            :scrollable="true"
            height="auto"
          >
            <div class="v--modal-close-top">
              <el-button
                @click="$modal.hide('request-dialog')"
                icon="el-icon-close"
                type="text"
              ></el-button>
            </div>
            <div class="title">例文を選ぶ</div>
            <div class="description">
              <p>選択した例文が追加されます。</p>
              <p class="attention">
                例文を選択すると、現在入力している文章は上書きされますのでご注意ください。
              </p>
            </div>
            <ul class="example-sentence">
              <li
                v-for="(item, idx) in exampleSentences.request"
                v-on:click="
                  formatData.request +=
                    item.description
                      .replace(/<br>/gi, '\n')
                      .replace('OOO', formatData.nowNensyu)
                      .replace('XXX', formatData.kibouNensyu) + '\n'
                  $modal.hide('request-dialog')
                "
                :key="idx"
              >
                <div class="title">{{ item.title }}</div>
                <div class="body" v-html="item.description"></div>
              </li>
            </ul>
            <div class="text-right">
              <el-button @click="$modal.hide('request-dialog')"
                >閉じる</el-button
              >
            </div>
          </modal>
          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 15 }"
            placeholder="給与・職種・勤務時間・勤務地など希望があれば入力"
            v-model="formatData.request"
            v-proofread
          >
          </el-input>
          <div class="attention-limit character" v-if="previewErrors.request">
            <i class="el-icon-warning"></i>
            入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>
        </div>
        <div
          class="card-header"
          v-if="getMode != 'production1'"
          style="text-align: center"
        >
          <h2 v-if="false">ヤギオファーに登録</h2>
          <p v-if="false">
            <a href="/yagiofferhelp" target="_blank"
              ><img
                src="/static/renew_img/bnr/yagioffer_lp_link_pc.png"
                class="pc"
                style="text-align: center; width: 70%" /><img
                src="/static/renew_img/bnr/yagioffer_lp_link_sp.png"
                class="sp"
                style="text-align: center; width: 100%"
            /></a>
          </p>
          <p v-if="false">以下の４つを選択するだけで登録完了</p>
          <p>
            あなたに興味をもった会社から直接オファーを受けることができます。
          </p>
          <el-checkbox v-if="false" v-model="formatData.registYagioffer"
            >規約に同意して登録する</el-checkbox
          >
          <p v-if="false" style="font-size: 70%">
            <a href="/yagiofferterms" target="_blank"
              >ヤギオファーの利用規約、個人情報保護方針</a
            >
          </p>
        </div>
        <div
          class="card-content"
          v-if="getMode != 'production1'"
          style="text-align: center"
        >
          <div class="edit-form-item select-list">
            <li class="select-item">
              <p class="item-name">学部・学科</p>
              <label class="selectbox-3">
                <select
                  v-model="formatData.department"
                  placeholder="選択してください"
                >
                  <option
                    v-for="item in departmentOptions"
                    :key="item"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </label>
            </li>
            <div class="item-body" v-if="false">
              <el-select
                v-model="formatData.department"
                placeholder="選択してください"
              >
                <el-option
                  v-for="item in departmentOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="edit-form-item select-list">
            <li class="select-item">
              <p class="item-name">希望勤務地</p>
              <label class="selectbox-3">
                <select
                  v-model="formatData.hopeAreaPref"
                  placeholder="選択してください"
                >
                  <option v-for="item in prefOptions" :key="item" :value="item">
                    {{ item }}
                  </option>
                </select>
              </label>
            </li>
            <div class="item-body" v-if="false">
              <el-select
                v-model="formatData.hopeAreaPref"
                placeholder="選択してください"
              >
                <el-option
                  v-for="item in prefOptions"
                  :key="item"
                  :label="item"
                  :style="item"
                  :value="item"
                ></el-option>
              </el-select>
            </div>
            <li class="select-item">
              <p class="item-name">希望業界</p>
              <label class="selectbox-3">
                <select
                  v-model="formatData.hopeIndustry"
                  placeholder="選択してください"
                >
                  <option
                    v-for="item in hopeIndustryOptions"
                    :key="item"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </label>
            </li>
            <div class="item-body" v-if="false">
              <el-select
                v-model="formatData.hopeIndustry"
                placeholder="選択してください"
              >
                <el-option
                  v-for="(item, index) in hopeIndustryOptions"
                  :key="item"
                  :style="item"
                  :value="item"
                >
                  <pre>{{ hopeIndustryOptionValues[index] }}</pre>
                </el-option>
              </el-select>
            </div>
            <li class="select-item">
              <p class="item-name">希望職種</p>
              <label class="selectbox-3">
                <select
                  v-model="formatData.hopeJobcategory"
                  placeholder="選択してください"
                >
                  <option
                    v-for="item in hopeJobcategoryOptions"
                    :key="item"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </label>
            </li>
            <div class="item-body" v-if="false">
              <select
                v-model="formatData.hopeJobcategory"
                placeholder="選択してください"
                style="left: 0; max-width: 100%"
              >
                <option
                  v-for="(item, index) in hopeJobcategoryOptions"
                  style="width: 100%"
                  :key="item"
                  :label="item"
                  :style="item"
                  :value="item"
                ></option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'create-date'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>履歴書の作成日を入力</h2>
          <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="create-date-action">
              <div class="action-item">
                <el-button
                  class="button-block"
                  :disabled="
                    $formLib.dateWithoutTime(formatData.createDate) ==
                    $formLib.dateWithoutTime($formLib.getToday())
                  "
                  @click="formatData.createDate = $formLib.getToday()"
                  >今日の日付を入力</el-button
                >
              </div>
              <div class="action-item">
                <el-button
                  class="button-block"
                  :disabled="
                    $formLib.dateWithoutTime(formatData.createDate) ==
                    $formLib.dateWithoutTime($formLib.getTommorow())
                  "
                  @click="formatData.createDate = $formLib.getTommorow()"
                  >明日の日付を入力</el-button
                >
              </div>
              <div class="action-item">
                <el-date-picker
                  v-model="formatData.createDate"
                  type="date"
                  :clearable="false"
                  placeholder="選択してください"
                  :format="'yyyy年M月d日'"
                  ref="create_date"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <br />
          <div v-if="$site.appFlag != 'b'">
            <el-collapse accordion v-model="activeName">
              <el-collapse-item name="1">
                <template slot="title">
                  <div class="yagitaku">
                    <span class="yagitaku_recommend">超簡単！</span
                    >1クリックでメール提出！ヤギのメール便サービス
                  </div>
                </template>
                <div class="el-collapse-item__content">
                  <p>
                    メーラーの立ち上げ不要！履歴書を作ってそのままノンストップで就職または転職を考えている企業先に、メールで履歴書を送信できます
                  </p>

                  <div class="bnr_item create-date_bnr">
                    <div class="bnr_txt create-date_txt">
                      <el-button
                        style="
                          width: 100%;
                          border: 0px;
                          padding: 0px;
                          background: #eff8f8;
                        "
                        :disabled="
                          !$deviceLib.isOnline || !isSendYagiPostEnabled
                        "
                        @click="
                          $eventHub.$emit('send-special-quickemail', formatId)
                        "
                      >
                        <h3>ヤギのメール便<span>をつかう</span></h3>
                      </el-button>
                    </div>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div
          class="card-header"
          stdyle="max-width: 40rem;margin: 2rem auto -3rem;"
        >
          <h2>作成した履歴書を確認</h2>
          <p>
            修正する場合は、プレビューの修正欄をクリックまたはステップを戻ることで修正することができます
          </p>
        </div>
      </div>
    </div>

    <div
      class="card"
      v-show="currentCardId == 'output'"
      v-if="getMode != 'production1'"
    >
      <download-item
        :formatId="formatId"
        :isSendYagiPostEnabled="isSendYagiPostEnabled"
        :isSendYagiEmailEnabled="isSendYagiEmailEnabled"
        :mailPdfEnabled="mailPdfEnabled"
        :downloadPdfEnabled="downloadPdfEnabled"
        :downloadActiveCollapses="downloadActiveCollapses"
      ></download-item>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #e3165c;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #e3165c;
  border-bottom: 1px solid #e3165c;
}

.create-date_bnr {
  margin: 15px 0;
}

.el-button--success.overwrite.overwrite,
.el-button--primary.overwrite {
  color: #000;
  background: #eff8f8;
  border: none;
  display: block;
  padding: 0;
  border-radius: 15px;
  white-space: normal;
  line-height: 1.8;
}

.el-button--success.overwrite.overwrite:hover,
.el-button--primary.overwrite:hover {
  background: none;
  color: #000;
}

.addition {
  font-size: 0.75rem;
  margin: 0.5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #eff8f8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;
}

.bnr_txt h3 {
  color: #e3165c;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>
<!--<style scoped>
.r-ai-format {
  border: 2px solid #8FBD67;
  border-radius: 10px;
  margin-top: 10px;
  background-image: -webkit-gradient(linear, left top, left bottom, from(rgba(255, 225, 0, .25)), to(rgba(255, 225, 0, 0)));
  background-image: linear-gradient(180deg, rgba(255, 225, 0, .25), rgba(255, 225, 0, 0));
  margin-bottom: 10px;
  padding: 15px;
  width: 100%;
}

.r-ai-format .r-midashi {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: bold;
  color: rgb(255, 255, 255);
  background: rgb(15, 153, 52);
  border-radius: 15px;
  padding: 2px 10px;
  margin-bottom: 5px;
}

.r-ai-format .title {
  font-size: 1rem;
  line-height: 1.4;
  font-weight: 700;
}

.r-ai-format .r-form-title {
  margin-top: 10px;
  align-items: center;
}

.r-ai-format .r-form-title span {
  width: 10%;
  font-size: 0.8rem;
  margin-right: 5px;
}

.r-ai-format .r-txtarea {
  min-height: 36px;
  height: 36px;
}

.r-ai-format .r-btn-wrap {
  margin-top: 10px;
}

.r-ai-format .r-ai-btn {
  position: relative;
  color: rgb(255, 255, 255);
  background-color: #8FBD67;
  border-color: #8FBD67;
  overflow: hidden;
}

.r-ai-format .r-ai-btn::before {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  background-image: linear-gradient(130deg, rgba(255, 255, 255, 0) 25%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 75%);
  -webkit-animation: shine 1s infinite;
  animation: shine 1s infinite;
}

@-webkit-keyframes shine {
  100% {
    left: 100%;
  }
}

@keyframes shine {
  100% {
    left: 100%;
  }
}

.r-ai-format .example-sentence li:hover {
  background: none;
}
</style>-->

<style scoped>
.yp-agent-register .card-header {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f8f8f8;
}

.yp-agent-register .yp-h2 {
  margin-bottom: 10px;
}

.yp-agent-register .card-content {
  border-top: none;
}

.yp-agent-register .yp-agent-list {
  margin-top: 20px;
}

.yp-agent-register .agent-logo {
  height: 50px;
  width: auto;
  margin-bottom: 10px;
  margin-right: 10px;
}

.yp-agent-register .agent-txt:last-child {
  margin-bottom: 10px;
}

.yp-agent-register .yp-agent-lead {
  color: #e3165c;
}

.yp-agent-register .yp-agent-memo {
  font-size: 0.75rem;
}

.yp-agent-register .consent-txt {
  align-items: center;
}

.yp-agent-register .consent-icon {
  width: auto;
  height: 16px;
  -o-object-fit: cover;
  object-fit: cover;
  margin-right: 5px;
}

.yp-agent-register .r-btn-wrap {
  margin-top: 10px;
}

.yp-agent-register .r-ai-btn {
  position: relative;
  color: rgb(255, 255, 255);
  background-color: #8fbd67;
  border-color: #8fbd67;
  overflow: hidden;
}

.yp-agent-register .r-ai-btn::before {
  content: '';
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  background-image: linear-gradient(
    130deg,
    rgba(255, 255, 255, 0) 25%,
    rgba(255, 255, 255, 0.5) 50%,
    rgba(255, 255, 255, 0) 75%
  );
  -webkit-animation: shine 1s infinite;
  animation: shine 1s infinite;
}

@-webkit-keyframes shine {
  100% {
    left: 100%;
  }
}

@keyframes shine {
  100% {
    left: 100%;
  }
}

.ai-payment-card-box {
  display: flex;
  flex-direction: column;
}
</style>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/prime-ai-reason.scss';

.select-list .selectbox-3 {
  display: inline-flex;
  align-items: center;
  position: relative;
}

.select-list .selectbox-3::after {
  position: absolute;
  right: 15px;
  width: 10px;
  height: 7px;
  background-color: #808286;
  clip-path: polygon(0 0, 100% 0, 50% 100%);
  content: '';
  pointer-events: none;
}

.select-list .selectbox-3 select {
  appearance: none;
  width: 500px;
  max-width: 100%;
  height: 2.8em;
  padding: 0.4em calc(0.8em + 30px) 0.4em 0.8em;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  background-color: #fff;
  color: #606266;
  font-size: 1em;
  cursor: pointer;
}

.select-list {
  width: 500px;
  max-width: 100%;
  margin: 0 auto;
}

.select-list .select-item {
  margin-bottom: 20px;
}

@media screen and (max-width: 640px) {
  .select-list .selectbox-3 select {
    width: 295px;
  }
}

.mypr-title-block {
  text-align: center;
  margin-bottom: 20px;

  .mypr-title-catch {
    display: inline-block;
    font-weight: bold;
    font-size: 12px;
    color: #ffffff;
    background: #0f9934;
    margin-bottom: 5px;
    padding: 0 5px;
  }

  h3 {
    font-weight: bold;
    font-size: 18px;
    line-height: 1.4;
    margin-bottom: 10px;
  }

  .mypr-lead {
    text-align: left;
    line-height: 1.4;
  }

  .mypr-attention {
    color: #e3165c;
    font-size: 12px;
  }
}

//.example-sentence-list {
//  margin-bottom: 20px;

//  .example-sentence-item {
//    margin-bottom: 10px;

//    &:last-child {
//      margin-bottom: 0;
//    }

//    .question-title {
//      font-weight: bold;
//      margin-bottom: 5px;

//      span {
//        color: #E3165C;
//        font-size: 10px;
//      }
//    }

//    &--self {
//      margin-bottom: 0;

//      .question-title {
//        margin-top: 10px;
//      }

//      .reason-txt {
//        font-size: 12px;
//      }
//    }

//    .selectbox-3 {
//      display: inline-flex;
//      align-items: center;
//      position: relative;

//      &::after {
//        position: absolute;
//        right: 15px;
//        width: 10px;
//        height: 7px;
//        background-color: #808286;
//        clip-path: polygon(0 0, 100% 0, 50% 100%);
//        content: '';
//        pointer-events: none;
//      }

//      select {
//        appearance: none;
//        width: 500px;
//        max-width: 100%;
//        height: 36px;
//        padding: .4em calc(.8em + 30px) .4em .8em;
//        border: 1px solid #dcdfe6;
//        border-radius: 3px;
//        background-color: #fff;
//        color: #606266;
//        font-size: 1em;
//        cursor: pointer;

//        @include max-width(sm) {
//          width: 295px;
//        }
//      }
//    }
//  }
//}

.example-sentence-block {
  margin-bottom: 0;
  border: 1px solid #90bd67;
  border-radius: 10px;
  padding: 20px 20px 10px;
}

.ai-mypr-modal {
  ::v-deep .v--modal {
    margin: 20px;
    width: auto !important;
    border-radius: 8px;
    padding: 20px;
    max-width: 560px;
    left: calc(50% - 270px) !important;

    @include max-width(sm) {
      left: 0px !important;
    }
  }
}

.prime-cv-block {
  text-align: center;

  ::v-deep .el-button {
    color: #fff;
    background-color: #e3165c;
    border-color: #e3165c;
    margin: 10px 0;
  }
}

.prime-cv-block-flex {
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  .el-button {
    margin: 0;
  }

  .r-ai-btn {
    span {
      font-size: 12px;
    }
  }
}
</style>
<script>
import HistoryItem from './RirekishoParts/HistoryItem'
import DownloadItem from './CommonParts/DownloadItem'
import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginSpecialForms'
import { StripeElementCard } from '@vue-stripe/vue-stripe'
import City from '@/plugins/tryt-city-master'
import YagiprimeWrapper from '@/components/Payment/YagiprimeWrapper.vue'
import { industryData } from '@/assets/formats/industryData'
import { jobTypeData } from '@/assets/formats/jobTypeData'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (cryptoObj.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  )
}
const HistoryData = function (year, month, description) {
  this.year = Number(year) || ''
  this.month = Number(month) || ''
  this.description = description || ''
  this.uuid = uuidv4()
}
export default {
  name: 'NewRirekishoEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItem,
    'download-item': DownloadItem,
    'auto-educational-backgrounds': AutoEducationalBackgrounds,
    'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms,
    StripeElementCard,
    YagiprimeWrapper
  },
  data: function () {
    return {
      industryData,
      jobTypeData,
      isPaymentYagiprime: true,
      aiResultView: false,
      completeBuyYagiprime: false,
      aiCampusHistoryResult: '',
      aiGakuchikaResult: '',
      aiResultMyprResult: '',
      viewYagiprimepayment: false,
      fullscreenLoading: false,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      matchingCompany: {},
      isMatching: false,
      trytCity: City,
      saveName: 'rirekisho',
      saveOtherName: 'shokumukeirekisho',
      paymentMethod: 'card',
      paymentMethodTab: 'card',
      isCampaign: false,
      isCampaign4Me: false,
      trial_campaign_id: 0,
      activeName: '1',
      formatData: {
        createDate: null,
        educationalHistories: [],
        jobHistories: [],
        licenseHistories: [],
        commuteDescription: '',
        commuteHours: '',
        commuteMinutes: '',
        spouseNumber: '',
        hasSpouse: false,
        underDutyToSupport: false,
        reason: '',
        reasonNew: '',
        request: '',
        nowNensyu: '',
        kibouNensyu: '',
        notDisplayRecommend: true
      },
      isWeekEndFlag: true,
      activeHistoryItem: '',
      isSendedYagishIntern: false,
      educationalResetDialogVisible: false,
      jobResetDialogVisible: false,
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isSendYagiEmailEnabled: true,
      isNew: false,
      textareaMinRows: 3,
      reasonLabel:
        '志望動機、特技、好きな学科、アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう',
      downloadActiveCollapses: ['postcard'],
      gradeYearOptions: [
        {
          value: '',
          label: ''
        },
        {
          value: '24',
          label: '24年卒'
        },
        {
          value: '25',
          label: '25年卒'
        },
        {
          value: '26',
          label: '26年卒'
        },
        {
          value: '27',
          label: '27年卒'
        },
        {
          value: '28',
          label: '28年卒'
        },
        {
          value: '99',
          label: 'その他'
        }
      ],
      departmentOptions: [
        '法学・政策系',
        '経済・経営系',
        '商学系',
        '社会・福祉系',
        '国際関係系',
        '外国語系',
        '文学系',
        '教員養成系',
        '教育系',
        '家政系',
        '宗教・神学系',
        '体育・芸術・音楽系',
        '商船系',
        '理系',
        '医療・保健系',
        '数理物系',
        '機械系',
        '電気・電子・制御系',
        '情報系',
        '応用物系',
        '土木系',
        '建築系',
        '生物系',
        '化学・物質系',
        '金属系',
        'その他理工系',
        '農業・農学系',
        '水産系',
        '畜産・酪農系',
        '薬学系',
        '医学・歯学系',
        '獣医系',
        '衛生・医療・介護系'
      ],
      graduationYearOptions: [
        '23年卒',
        '24年卒',
        '25年卒',
        '26年卒',
        '27年卒',
        '28年卒'
      ],
      hopeIndustryOptions: [
        'IT・通信',
        'ソフトウェア・情報処理',
        'インターネット関連・ゲーム・アプリ関連',
        '機械・産業用装置・電機・OA機器',
        '自動車・自動車部品・輸送用機器',
        'コンピュータ・通信機器・精密機器',
        '電子部品・半導体',
        '食品・飲料・たばこ・飼料',
        '化学・医薬・化粧品',
        '鉄鋼・非鉄金属・金属製品',
        '石油・石炭・ゴム・プラスチック',
        'ガラス・セラミック・セメント',
        'パルプ・紙・紙加工・印刷・印刷関連',
        '日用品・文具・オフィス用品',
        '建材・エクステリア',
        'インテリア・住宅関連',
        'アパレル・服飾関連',
        'スポーツ・玩具・ゲーム機器',
        'その他メーカー・製造関連',
        '電気・ガス・石油・水道',
        '放送（テレビ・ラジオ含む）',
        '新聞・出版',
        '広告',
        'その他（芸能・エンタテインメント関連等）',
        '運輸（鉄道・航空・海運・物流等）',
        '総合商社',
        '専門商社',
        '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター',
        '通信販売、専門店・その他小売り',
        '銀行（協同組織金融含む）',
        '証券',
        '保険',
        'その他金融（クレジット等）',
        'リース・レンタル',
        'ディベロッパー',
        '建設・建築設計・ハウスメーカー',
        '設備関連',
        'プラント・プラントエンジニアリング',
        '不動産取引・不動産賃貸・不動産管理',
        'デザイン・芸術関連',
        'コンサルティング・マーケティング・調査',
        'その他専門・技術サービス',
        'ホテル・旅館',
        '外食',
        'その他フード',
        '理美容・エステ・フィットネスクラブ',
        '旅行・観光',
        '家事サービス・クリーニング',
        '冠婚葬祭',
        'その他生活関連サービス',
        'アミューズメント・レジャーサービス',
        '教育関連',
        '医療・保育・介護、福祉',
        '環境・リサイクル・廃棄物処理',
        '整備・修理',
        '人材サービス',
        'その他事業サービス（警備、コールセンター等）',
        'その他'
      ],
      hopeIndustryOptionValues: [
        'IT・通信',
        'ソフトウェア・情報処理',
        'インターネット関連・ゲーム・アプリ関連',
        '機械・産業用装置・電機・OA機器',
        '自動車・自動車部品・輸送用機器',
        'コンピュータ・通信機器・精密機器',
        '電子部品・半導体',
        '食品・飲料・たばこ・飼料',
        '化学・医薬・化粧品',
        '鉄鋼・非鉄金属・金属製品',
        '石油・石炭・ゴム・プラスチック',
        'ガラス・セラミック・セメント',
        'パルプ・紙・紙加工・印刷・印刷関連',
        '日用品・文具・オフィス用品',
        '建材・エクステリア',
        'インテリア・住宅関連',
        'アパレル・服飾関連',
        'スポーツ・玩具・ゲーム機器',
        'その他メーカー・製造関連',
        '電気・ガス・石油・水道',
        '放送（テレビ・ラジオ含む）',
        '新聞・出版',
        '広告',
        'その他（芸能・エンタテインメント関連等）',
        '運輸（鉄道・航空・海運・物流等）',
        '総合商社',
        '専門商社',
        '百貨店・スーパー・ドラッグストア・コンビニ・ホームセンター',
        '通信販売、専門店・その他小売り',
        '銀行（協同組織金融含む）',
        '証券',
        '保険',
        'その他金融（クレジット等）',
        'リース・レンタル',
        'ディベロッパー',
        '建設・建築設計・ハウスメーカー',
        '設備関連',
        'プラント・プラントエンジニアリング',
        '不動産取引・不動産賃貸・不動産管理',
        'デザイン・芸術関連',
        'コンサルティング・マーケティング・調査',
        'その他専門・技術サービス',
        'ホテル・旅館',
        '外食',
        'その他フード',
        '理美容・エステ・フィットネスクラブ',
        '旅行・観光',
        '家事サービス・クリーニング',
        '冠婚葬祭',
        'その他生活関連サービス',
        'アミューズメント・レジャーサービス',
        '教育関連',
        '医療・保育・介護、福祉',
        '環境・リサイクル・廃棄物処理',
        '整備・修理',
        '人材サービス',
        'その他事業サービス（警備、コールセンター等）',
        'その他'
      ],
      hopeJobcategoryOptions: [
        '営業',
        '事務・秘書・受付',
        '経理',
        '総務人事',
        'バイヤー',
        '法務',
        '知的財産部門',
        '企画',
        'マーケティング',
        '宣伝・広報',
        '経営企画',
        '経営コンサルタント',
        '為替ディーラー・トレーダー',
        '証券アナリスト',
        '融資・資産運用(ファンドマネージャー等）',
        'ファイナンシャルアドバイザー',
        'アクチュアリー',
        'システムエンジニア・プログラマ',
        'Webエンジニア',
        'ネットワークエンジニア',
        'セキュリティエンジニア',
        'インフラ・データエンジニア',
        'AIエンジニア',
        '組み込みエンジニア',
        'カスタマーエンジニア',
        '社内SE・情シス',
        '研究職（製造系）',
        '設計開発',
        '生産・製造',
        '物流・在庫管理',
        'セールスエンジニア',
        '品質管理',
        '医療技術',
        'MR（医薬情報担当者）',
        '研究開発（医薬系）',
        '薬剤師',
        '栄養士',
        '福祉士・介護士・ホームヘルパー',
        '講師・インストラクター',
        '専門コンサルタント',
        '建築・土木設計',
        '施工管理',
        'Webプロデューサー・ディレクター',
        'Webデザイナー',
        'デザイナー',
        'ゲームクリエイター',
        'ゲームプログラマ',
        'データサイエンティスト・アナリスト',
        '記者・ライター',
        '編集・制作',
        '販売・接客',
        '店長（店舗経営・運営）',
        'スーパーバイザー',
        '農業',
        '林業',
        '漁業'
      ],
      prefOptions: [
        '北海道',
        '青森県',
        '岩手県',
        '宮城県',
        '秋田県',
        '山形県',
        '福島県',
        '茨城県',
        '栃木県',
        '群馬県',
        '埼玉県',
        '千葉県',
        '東京都',
        '神奈川県',
        '新潟県',
        '富山県',
        '石川県',
        '福井県',
        '山梨県',
        '長野県',
        '岐阜県',
        '静岡県',
        '愛知県',
        '三重県',
        '滋賀県',
        '京都府',
        '大阪府',
        '兵庫県',
        '奈良県',
        '和歌山県',
        '鳥取県',
        '島根県',
        '岡山県',
        '広島県',
        '山口県',
        '徳島県',
        '香川県',
        '愛媛県',
        '高知県',
        '福岡県',
        '佐賀県',
        '長崎県',
        '熊本県',
        '大分県',
        '宮崎県',
        '鹿児島県',
        '沖縄県',
        '海外'
      ]
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return this.$yagi.isFromMynabi === 1
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    loading_on: function () {
      this.fullscreenLoading = true
    },
    loading_off: function () {
      this.fullscreenLoading = false
      this.completeBuyYagiprime = true
    },
    goYagiprimeRegister: function () {
      const app = this

      app.$cookies.config(60 * 60 * 24, '')
      const route_id = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      app.$cookies.set(
        '_YAGISH_YAGIPRIME_ROUTE_ID',
        route_id + '#self_introduction',
        null,
        null,
        'yagish.jp'
      )
      app.$cookies.set(
        '_YAGISH_YAGIPRIME_ROUTE_ID',
        route_id + '#self_introduction',
        null,
        null,
        'localhost'
      )
      location.href = '/yagiprime_register'
    },
    getAIMypr: function () {
      const app = this
      // console.error(app.formatData.educationalHistories.length)
      // console.error(app.formatData.educationalHistories[app.formatData.educationalHistories.length - 1].description)
      // return
      app.fullscreenLoading = true
      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      if (app.formatData.educationalHistories.length > 0) {
        formData.append(
          'education',
          app.formatData.educationalHistories[
            app.formatData.educationalHistories.length - 1
          ].description
        )
      } else {
        formData.append('education', '')
      }
      formData.append('strength', this.formatData.ai_mypr_good)
      formData.append('weakness', this.formatData.ai_mypr_bad)
      formData.append('hobby', this.formatData.ai_mypr_hobby)
      formData.append('future', this.formatData.ai_mypr_wanted)
      formData.append('free', this.formatData.ai_mypr_appeal)

      formData.append('app_flag', this.$site.appFlag)
      formData.append(
        'device_flg',
        this.$deviceLib.isMobileDevice ? 'SP' : 'PC'
      )
      formData.append('version', '3')
      formData.append('site_flag', 'r')

      this.$axios
        .post(this.$varuna.endPoints.aiIntroduce, formData, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.success)
          if (response.data.success) {
            app.aiResultMyprResult = response.data.message
            app.aiResultView = true
            app.$message({
              message: '取得しました',
              type: 'success'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          console.error(error.response.data.message)
          if (
            error.response.data.message == 'AIの使用回数が上限に達しました。'
          ) {
            app.aiResultView = true
          }
          if (error.response.data.message) {
            app.$message({
              message: error.response.data.message,
              type: 'error'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    },
    viewPaymentYagiprime: function () {
      const app = this
      this.$yagiprimePaymentService.useFeature(
        this,
        'self-mypr-new-rirekisho',
        {
          onSuccess: () => {
            console.log('課金成功メェ〜')
            this.$message({
              message:
                'ヤギプラ加入に成功しました。5秒ほどお待ちいただくと、全文が適用されます。',
              type: 'success'
            })
            // aiSentenseContinueのAPIを叩く
            // aiCampusHistoryResult, aiGakuchikaResult
            // getAIMyprNewContinue
            app.getAIMyprNewContinue()
          },
          onAlreadyPremium: () => {
            app.aiResultView = true
            app.getAIMyprNewContinue()
          },
          onCancel: () => {
            console.log('課金失敗メェ〜')
            app.fullscreenLoading = false
          }
        }
      )
    },
    paymentYagiprime: function () {
      console.error(this.paymentMethod)
      const app = this
      if (app.isPaymentYagiprime && this.paymentMethod == 'card') {
        this.$refs.stripeCardElememt.submit()
      }
    },
    tokenCreated(token, merchant_payment_id = '') {
      const app = this
      app.fullscreenLoading = true
      app.isPaymentYagiprime = false
      app.$eventHub.$emit('loading_on')
      this.token = ''
      if (token) {
        this.token = token.id
      }
      if (merchant_payment_id) {
        this.paymentMethodTab = 'paypay'
      }
      const formData = new FormData()
      formData.append('stripe_token', this.token)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      formData.append('app_flag', this.$site.appFlag)
      formData.append(
        'device_flg',
        this.$deviceLib.isMobileDevice ? 'SP' : 'PC'
      )
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('payment_method', this.paymentMethodTab)
      if (app.isCampaign) {
        formData.append('trial_campaign_id', app.trial_campaign_id)
      }
      this.$axios
        .post(this.$varuna.endPoints.subscription, formData, { timeout: 60000 })
        .then(function (response) {
          if (response.status == 201) {
            app.completeBuyYagiprime = true
            app.$globalVar.isYagiPrime = true
            const subformData = new FormData()
            subformData.append('route', 'rirekisho_ai_new')
            subformData.append('uuid', app.$firebase.user.uid)
            app.$axios.post(
              app.$varuna.endPoints.setYagiprimeEntrySource,
              subformData,
              { timeout: 60000 }
            )
            app.$message({
              message: '購入完了しました',
              type: 'success'
            })
            formData.append(
              'current_location',
              app.getPrefName(app.basicData.address1)
            )
            formData.append('preferred_job', app.formatData.hopeJobcategory)
            formData.append('app_flag', app.$site.appFlag)
            formData.append(
              'device_flg',
              app.$deviceLib.isMobileDevice ? 'SP' : 'PC'
            )
            formData.append('version', '3')
            formData.append('site_flag', 'r')
            formData.append('age', app.basicData.age)
            formData.append('applicant_type_id', '2')
            app.$axios
              .post(app.$varuna.endPoints.primeAdditionalInfo, formData, {
                timeout: 60000
              })
              .then(function (response) {
                console.error(response.data)
                if (response.data.success) {
                  app.matchingCompany = response.data.matching_company
                  app.isMatching = response.data.is_matching
                }
              })
              .catch(function (error) {})
              .finally(function () {
                app.fullscreenLoading = false
              })
          }
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    },
    yagiprimePaypay: function (param) {
      const app = this
      app.fullscreenLoading = true

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('subscription_type', 1)

      const route_id = app.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID')
      if (route_id) {
        formData.append('route', route_id)
      } else {
        formData.append('route', '')
      }
      formData.append('app_flag', this.$site.appFlag)
      formData.append(
        'device_flg',
        this.$deviceLib.isMobileDevice ? 'SP' : 'PC'
      )
      formData.append('version', '3')
      formData.append('site_flag', 'r')
      formData.append('redirect_url', window.location.href)

      this.$axios
        .post(this.$varuna.endPoints.paypaySubscriptions, formData, {
          timeout: 60000
        })
        .then(function (response) {
          console.error(response.data.authorization_url)
          location.href = response.data.authorization_url
        })
        .catch(function (error) {
          app.$message({
            message: '決済失敗しました',
            type: 'error'
          })
          app.$eventHub.$emit('payment_yagiprime_result', 'error')
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    },
    getAIMyprNew: function () {
      const app = this

      app.fullscreenLoading = true

      this.$nextTick(() => {
        const formDataCampus = new FormData()
        if (app.$firebase.isAuthenticated) {
          formDataCampus.append('uuid', this.$firebase.user.uid)
        }
        formDataCampus.append('content', app.formatData.campus_history_content)
        formDataCampus.append('summary', app.formatData.campus_history_summary)

        const campusPromise = this.$axios
          .post(
            this.$varuna.endPoints.aiIntroduceCampusHistory,
            formDataCampus,
            { timeout: 60000 }
          )
          .then(function (response) {
            if (response.data.success) {
              app.aiCampusHistoryResult =
                '<得意な科目または研究課題・ゼミ・卒論など><br>' +
                response.data.message
              app.aiResultView = true
              app.$message({ message: '取得しました', type: 'success' })
            } else {
              app.$message({ message: '失敗しました', type: 'error' })
            }
          })
          .catch(function (error) {
            const msg =
              error.response &&
              error.response.data &&
              error.response.data.message
            app.$message({ message: msg || '失敗しました', type: 'error' })
          })

        const formDataGakuchika = new FormData()
        if (app.$firebase.isAuthenticated) {
          formDataGakuchika.append('uuid', this.$firebase.user.uid)
        }
        formDataGakuchika.append('content', app.formatData.gakuchika_content)
        formDataGakuchika.append('summary', app.formatData.gakuchika_summary)

        const gakuchikaPromise = this.$axios
          .post(
            this.$varuna.endPoints.aiIntroduceGakuchika,
            formDataGakuchika,
            { timeout: 60000 }
          )
          .then(function (response) {
            if (response.data.success) {
              app.aiGakuchikaResult =
                '<学生生活で力を注いだこと><br>' + response.data.message
              app.aiResultView = true
              app.$message({ message: '取得しました', type: 'success' })
            } else {
              app.$message({ message: '失敗しました', type: 'error' })
            }
          })
          .catch(function (error) {
            const msg =
              error.response &&
              error.response.data &&
              error.response.data.message
            app.$message({ message: msg || '失敗しました', type: 'error' })
          })

        Promise.all([campusPromise, gakuchikaPromise]).finally(function () {
          app.fullscreenLoading = false
        })
      })
    },
    getAIMyprNewContinue: function () {
      const app = this
      app.fullscreenLoading = true
      const formData = new FormData()
      if (app.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }
      // formData.append('education', app.formatData.educationalHistories[app.formatData.educationalHistories.length - 1].description)
      // formData.append('strength', this.formatData.ai_mypr_good)
      // formData.append('weakness', this.formatData.ai_mypr_bad)
      // formData.append('hobby', this.formatData.ai_mypr_hobby)
      // formData.append('future', this.formatData.ai_mypr_wanted)
      // formData.append('free', this.formatData.ai_mypr_appeal)
      console.log(app.aiCampusHistoryResult)
      console.log(app.aiGakuchikaResult)
      const data = this.aiCampusHistoryResult + '\n\n' + this.aiGakuchikaResult
      formData.append('data', data)

      this.$axios
        .post(this.$varuna.endPoints.aiSentenseContinue, formData, {
          timeout: 60000
        })
        .then(function (response) {
          if (response.data.success) {
            // app.aiResultMyprResult = response.data.message
            // aiCampusHistoryResult, aiGakuchikaResult
            // response.data.messageを<br>で分割する
            const messages = response.data.message.split('\n\n')
            app.aiCampusHistoryResult = messages[0]
            app.aiGakuchikaResult = messages[1]
            app.aiResultView = true
            app.$message({ message: '取得しました', type: 'success' })
          } else {
            app.$message({ message: '失敗しました', type: 'error' })
          }
        })
        .catch(function (error) {
          const msg =
            error.response && error.response.data && error.response.data.message
          app.$message({ message: msg || '失敗しました', type: 'error' })
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    },
    setEducationalBackgrounds: function (historyList) {
      this.formatData.educationalHistories = []
      // 常に先頭から追加
      let index = 0
      for (const key in historyList) {
        const item = historyList[key]
        this.addEducationalHistory(index++, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    addExampleSentences: function (selectedSentences, modal) {
      const tArea = this.$refs.yourTextarea
      const startPos = tArea.selectionStart
      const endPos = tArea.selectionEnd
      const tmpStr = tArea.value
      console.error(tArea)
      console.error(startPos)
      this.formatData.reasonNew =
        tmpStr.substring(0, startPos) +
        selectedSentences +
        tmpStr.substring(endPos, tmpStr.length)
      modal.hide('reason-dialog')
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (const key in historyList) {
        const item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetEducationalBackgrounds: function () {
      this.formatData.educationalHistories = []
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new HistoryData(columns.year, columns.month, columns.description)
    },
    addHistory: function (historyList, index, refId, columns) {
      const newHistoryItem = this.createHistoryItem(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    addEducationalHistory: function (index, columns) {
      this.addHistory(
        this.formatData.educationalHistories,
        index,
        'EducationalHistory_',
        columns
      )
    },
    moveEducationalHistory: function (params) {
      this.moveHistory(this.formatData.educationalHistories, params)
    },
    addJobHistory: function (index, columns) {
      this.addHistory(
        this.formatData.jobHistories,
        index,
        'JobHistory_',
        columns
      )
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    addLicenseHistory: function (index, columns) {
      this.addHistory(
        this.formatData.licenseHistories,
        index,
        'LicenseHistory_',
        columns
      )
    },
    moveLicenseHistory: function (params) {
      this.moveHistory(this.formatData.licenseHistories, params)
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(
          fromIndex - 1,
          2,
          historyList[fromIndex],
          historyList[fromIndex - 1]
        )
      } else if (to === 'down') {
        historyList.splice(
          fromIndex,
          2,
          historyList[fromIndex + 1],
          historyList[fromIndex]
        )
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteEducationalHistory: function (index) {
      this.formatData.educationalHistories.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteLicenseHistory: function (index) {
      this.formatData.licenseHistories.splice(index, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
      const element = document.getElementById(id)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    },
    setIsSendedYagishIntern: function (rslt) {
      this.isSendedYagishIntern = rslt
    },
    authStateChanged: async function () {
      const app = this
      app.fullscreenLoading = true
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      this.$axios
        .post(this.$varuna.endPoints.canUseTrialCampaign, formData, {
          timeout: 60000
        })
        .then(function (response) {
          console.error(response.data.can_use_trial_campaign)
          if (response.data.can_use_trial_campaign) {
            app.isCampaign4Me = true
          } else {
            app.isCampaign4Me = false
            app.isCampaign = false
            app.trial_campaign_id = null
          }
        })
        .catch(function (error) {})
        .finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  created: function () {
    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    if (this.getMode != 'production') {
      this.isWeekEndFlag = true
    }
    const app = this
    this.$axios
      .get(this.$varuna.endPoints.getTrialCampaign, null, { timeout: 60000 })
      .then(function (response) {
        console.error(app.isCampaign)
        console.error(response.data[0])
        const today = new Date() // 本日の日付
        const startDate = new Date(response.data[0].trial_campaign_start_date)
        const endDate = new Date(response.data[0].trial_campaign_end_date)

        // キャンペーンが有効かつ、本日がキャンペーン期間内かを確認
        if (
          response.data[0].trial_campaign_is_active &&
          today >= startDate &&
          today <= endDate
        ) {
          app.isCampaign = true
          app.trial_campaign_id = response.data[0].trial_campaign_id
        }
        console.error(app.isCampaign)
      })
      .catch(function () {})
      .finally(function () {
        app.fullscreenLoading = false
      })

    this.$yagiprimePaymentService.init(this)
  },
  watch: {
    'formatData.createDate': function (newValue, oldValue) {
      this.formatData.writeDate = this.$formLib.dateFormat(
        newValue,
        'yyyy年 m月 d日'
      )
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    // if (!this.formatData.registYagioffer) {
    //   this.formatData.registYagioffer = true
    // }
    this.formatData.registYagioffer = true
    if (this.formatId === 'rirekisho_job_new') {
      this.textareaMinRows = 10
      this.reasonLabel =
        '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう'
    }
    if (this.formatId === 'rirekisho_job_new_single') {
      this.textareaMinRows = 6
      this.reasonLabel =
        '自己PR・ゼミ研究・得意科目・志望動機・特技・アピールポイントなど。書き方に困ったときは例文を元に編集してみましょう'
    }
    this.reasonLabel =
      '書類審査、合格のカギは志望動機と自己PRの表現力！最新のAIを使って表現力アップ！'

    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on(
      'set_is_sendedYagishIntern',
      this.setIsSendedYagishIntern
    )
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
    this.$eventHub.$on('loading_on', this.loading_on)
    this.$eventHub.$on('loading_off', this.loading_off)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off(
      'set_isSendedYagishIntern',
      this.setIsSendedYagishIntern
    )
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
    this.$eventHub.$off('loading_on', this.loading_on)
    this.$eventHub.$off('loading_off', this.loading_off)
    this.$yagiprimePaymentService.cleanup(this)
  }
}
</script>
